import React from "react";
type SectionHeadProps = {
  eyebrow: string;
  title: string;
  highlight: string;
  lead?: string;
  tone?: "light" | "dark";
  className?: string;
};
export function SectionHead({
  eyebrow,
  title,
  highlight,
  lead,
  tone = "light",
  className = ""
}: SectionHeadProps) {
  const dark = tone === "dark";
  return <div className={`mx-auto mb-10 max-w-[760px] text-center md:mb-14 ${className}`} data-id="element-132" data-mp="2cnmh1vehn552">
      <p className={`mb-3 text-xs font-bold uppercase tracking-[0.2em] ${dark ? "text-teal-bright" : "text-teal"}`} data-id="element-133" data-mp="2hmfyfywwbgai">
        {eyebrow}
      </p>
      <h2 className={`font-display text-[40px] font-extrabold uppercase leading-[0.98] tracking-[-0.01em] sm:text-5xl md:text-[56px] ${dark ? "text-white" : "text-navy"}`} data-id="element-134" data-mp="2miwioi0z5aib">
        {title} <span className={dark ? "text-teal-bright" : "text-teal"} data-id="element-135" data-mp="2wcdetsol31p5">{highlight}</span>
      </h2>
      {lead && <p className={`mx-auto mt-5 max-w-[620px] text-[17px] ${dark ? "text-white/75" : "text-ink/80"}`} data-id="element-136" data-mp="35b8l14rmobsg">{lead}</p>}
    </div>;
}